export const environment = {
  production: false,
  paxarelUrl: 'https://api-core-dev.paxarel.com/api',
  paxarelApiKey: 'c323c28b-87d0-4a64-a472-0a78a7b3777b',
  apiUrl: 'https://virtual-seller-api-dev.tercerpiso.tech'
};
